export const LIST_SERVICE_TYPE_REQUEST = 'LIST_SERVICE_TYPE_REQUEST'
export const LIST_SERVICE_TYPE_SUCCESS = 'LIST_SERVICE_TYPE_SUCCESS'
export const LIST_SERVICE_TYPE_FAIL = 'LIST_SERVICE_TYPE_FAIL'

export const LIST_SERVICE_TYPE_SUMMARY_REQUEST = 'LIST_SERVICE_TYPE_SUMMARY_REQUEST'
export const LIST_SERVICE_TYPE_SUMMARY_SUCCESS = 'LIST_SERVICE_TYPE_SUMMARY_SUCCESS'
export const LIST_SERVICE_TYPE_SUMMARY_FAIL = 'LIST_SERVICE_TYPE_SUMMARY_FAIL'

export const CREATE_SERVICE_TYPE_REQUEST = 'CREATE_SERVICE_TYPE_REQUEST'
export const CREATE_SERVICE_TYPE_SUCCESS = 'CREATE_SERVICE_TYPE_SUCCESS'
export const CREATE_SERVICE_TYPE_FAIL = 'CREATE_SERVICE_TYPE_FAIL'

export const DETAIL_SERVICE_TYPE_REQUEST = 'DETAIL_SERVICE_TYPE_REQUEST'
export const DETAIL_SERVICE_TYPE_SUCCESS = 'DETAIL_SERVICE_TYPE_SUCCESS'
export const DETAIL_SERVICE_TYPE_FAIL = 'DETAIL_SERVICE_TYPE_FAIL'

export const UPDATE_SERVICE_TYPE_REQUEST = 'UPDATE_SERVICE_TYPE_REQUEST'
export const UPDATE_SERVICE_TYPE_SUCCESS = 'UPDATE_SERVICE_TYPE_SUCCESS'
export const UPDATE_SERVICE_TYPE_FAIL = 'UPDATE_SERVICE_TYPE_FAIL'

export const DELETE_SERVICE_TYPE_REQUEST = 'DELETE_SERVICE_TYPE_REQUEST'
export const DELETE_SERVICE_TYPE_SUCCESS = 'DELETE_SERVICE_TYPE_SUCCESS'
export const DELETE_SERVICE_TYPE_FAIL = 'DELETE_SERVICE_TYPE_FAIL'

export const RESET_SERVICE_TYPE = 'RESET_SERVICE_TYPE'